import { FormattedDate, FormattedMessage } from "react-intl";

import { Descriptions, Typography } from "antd";

import { CmtSectionCard } from "@app/components/common/CmtSectionCard.tsx";
import { CmtBenchField } from "@app/components/users/field/CmtBenchField.tsx";
import { CmtDepartmentField } from "@app/components/users/field/CmtDepartmentField.tsx";
import { User } from "@app/models/User.ts";

interface CmtUserInformationProps {
  user: User;
}

export const CmtUserInformation = ({ user }: CmtUserInformationProps) => (
  <CmtSectionCard
    title={
      <FormattedMessage
        id="collaborator.information"
        defaultMessage="Information"
      />
    }
  >
    <Descriptions
      column={1}
      colon={false}
      labelStyle={{ width: "45%" }}
      items={[
        {
          key: "job",
          label: <FormattedMessage id="table.job" defaultMessage="Job Title" />,
          children: user.userJob?.name ?? "-",
        },
        {
          key: "department",
          label: (
            <FormattedMessage
              id="table.department"
              defaultMessage="Department"
            />
          ),
          children: user.department ? (
            <CmtDepartmentField department={user.department} />
          ) : (
            "-"
          ),
        },
        ...(user.isOnBench
          ? [
              {
                key: "isOnBench",
                label: (
                  <FormattedMessage
                    id="collaborator.status"
                    defaultMessage="Status"
                  />
                ),
                children: <CmtBenchField />,
              },
            ]
          : []),
        {
          key: "email",
          label: "Email",
          children: <Typography.Text copyable>{user.email}</Typography.Text>,
        },
        {
          key: "startingDate",
          label: (
            <FormattedMessage
              id="table.starting_date"
              defaultMessage="Starting Date"
            />
          ),
          children: (
            <FormattedDate
              value={new Date(user.startingDate)}
              dateStyle="long"
            />
          ),
        },
        {
          key: "providerId",
          label: <FormattedMessage id="table.id" defaultMessage="SAP ID" />,
          children: (
            <Typography.Text copyable>
              {String(user.providerId)}
            </Typography.Text>
          ),
        },
        {
          key: "erpLastModified",
          label: (
            <FormattedMessage
              id="table.last_modification"
              defaultMessage="Last Modified (SAP)"
            />
          ),
          children: (
            <FormattedDate
              value={new Date(user.erpLastModified)}
              dateStyle="medium"
              timeStyle="short"
            />
          ),
        },
      ]}
    />
  </CmtSectionCard>
);
